import React, { useEffect, useState } from 'react';
import { jobLabel } from '../utils/ui';

// Big red "priority directive" cards for the person who received them. Renders
// NOTHING when there are none (so the mobile home stays clean). The newest is
// shown ~2x; any others stack smaller beneath it.
const API_BASE = process.env.REACT_APP_API_BASE || 'https://app.titanelectricreno.com:8080/api';
function getToken() { try { return JSON.parse(localStorage.getItem('titan_session') || 'null')?.token; } catch { return null; } }
function apiFetch(path, opts = {}) {
  return fetch(`${API_BASE}${path}`, { ...opts, headers: { 'Content-Type': 'application/json', 'x-worker-token': getToken(), ...opts.headers } })
    .then(r => r.ok ? r.json() : Promise.reject());
}

function DirectiveCard({ d, big, onAct }) {
  const [replying, setReplying] = useState(false);
  const [reply, setReply] = useState(d.reply || '');
  const acked = d.status === 'acknowledged';
  const pad = big ? '20px 22px' : '14px 16px';
  const titleSize = big ? 20 : 16;
  return (
    <div style={{ background: 'linear-gradient(135deg,#dc2626,#b91c1c)', color: '#fff', borderRadius: 16, padding: pad, boxShadow: '0 8px 24px rgba(220,38,38,0.35)' }}>
      <div style={{ display: 'flex', alignItems: 'center', gap: 8, fontSize: 11, fontWeight: 800, letterSpacing: 0.6, textTransform: 'uppercase', opacity: 0.9 }}>
        <span style={{ width: 8, height: 8, borderRadius: '50%', background: '#fff', boxShadow: '0 0 0 3px rgba(255,255,255,0.35)' }} />
        Priority from {d.from_name}{acked ? ' · you’re on it' : ''}
      </div>
      <div style={{ fontSize: titleSize, fontWeight: 800, lineHeight: 1.3, margin: '8px 0 4px' }}>{d.text}</div>
      {(d.project_number || d.project_name) && (
        <div style={{ fontSize: 12.5, opacity: 0.9 }}>📍 {jobLabel({ project_number: d.project_number, name: d.project_name })}</div>
      )}
      {d.reply && !replying && <div style={{ fontSize: 12.5, opacity: 0.95, marginTop: 6, fontStyle: 'italic' }}>“{d.reply}”</div>}
      <div style={{ display: 'flex', gap: 8, marginTop: big ? 16 : 12, flexWrap: 'wrap' }}>
        {!acked && (
          <button onClick={() => onAct(d.id, 'ack')} style={{ background: 'rgba(255,255,255,0.2)', border: '1.5px solid rgba(255,255,255,0.5)', color: '#fff', borderRadius: 10, padding: big ? '11px 20px' : '8px 14px', fontWeight: 800, fontSize: big ? 15 : 13, cursor: 'pointer' }}>👍 Got it</button>
        )}
        <button onClick={() => onAct(d.id, 'done')} style={{ background: '#fff', border: 'none', color: '#b91c1c', borderRadius: 10, padding: big ? '11px 22px' : '8px 16px', fontWeight: 800, fontSize: big ? 15 : 13, cursor: 'pointer' }}>✓ Done</button>
        <button onClick={() => setReplying(v => !v)} style={{ background: 'none', border: 'none', color: '#fff', fontWeight: 700, fontSize: big ? 14 : 12.5, cursor: 'pointer', opacity: 0.9, textDecoration: 'underline' }}>Reply</button>
      </div>
      {replying && (
        <div style={{ display: 'flex', gap: 8, marginTop: 10 }}>
          <input value={reply} onChange={e => setReply(e.target.value)} placeholder="Quick note back…"
            style={{ flex: 1, borderRadius: 8, border: 'none', padding: '9px 12px', fontSize: 14 }} />
          <button onClick={() => { onAct(d.id, 'reply', { reply }); setReplying(false); }} style={{ background: 'rgba(255,255,255,0.25)', border: 'none', color: '#fff', borderRadius: 8, padding: '9px 14px', fontWeight: 700, cursor: 'pointer' }}>Send</button>
        </div>
      )}
    </div>
  );
}

// unseenOnly (the PM dashboard): only the ones not yet acknowledged — after "Got it" they
// live in the dashboard's Bids & Banners tile. onChange: after any action.
export default function DirectiveCards({ onCount, unseenOnly = false, onChange }) {
  const [items, setItems] = useState([]);
  useEffect(() => {
    let alive = true;
    const load = () => apiFetch('/directives/mine').then(d => { if (alive) { const a = (Array.isArray(d) ? d : []).filter(x => !unseenOnly || x.status !== 'acknowledged'); setItems(a); onCount && onCount(a.length); } }).catch(() => {});
    load();
    const t = setInterval(load, 45000);
    return () => { alive = false; clearInterval(t); };
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  async function onAct(id, action, body) {
    try {
      const updated = await apiFetch(`/directives/${id}/${action}`, { method: 'PATCH', ...(body ? { body: JSON.stringify(body) } : {}) });
      setItems(list => {
        const next = action === 'done' || (unseenOnly && action === 'ack') ? list.filter(x => x.id !== id) : list.map(x => x.id === updated.id ? updated : x);
        onCount && onCount(next.length);
        return next;
      });
      onChange && onChange();
    } catch (e) { window.alert(e?.error || e?.message || 'Could not update that — check your connection and try again.'); }
  }

  if (!items.length) return null;
  const [top, ...rest] = items;
  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 10, marginBottom: 22 }}>
      <DirectiveCard d={top} big onAct={onAct} />
      {rest.map(d => <DirectiveCard key={d.id} d={d} onAct={onAct} />)}
    </div>
  );
}
